import { countCampaigns, listCampaigns, listSites } from "@/trpc/calls";

const getSitesData = async (variables) => listSites(variables);

const getCountCampaigns = async (variables) => countCampaigns(variables);

const getAllCampaignsData = async (variables) => listCampaigns(variables);

export { getSitesData, getCountCampaigns, getAllCampaignsData };
